import React from 'react';
import { Skeleton } from '../../index';

const TitleSkeleton = ({ animation, isLoading, width, height, children }) => {
  return (
    <Skeleton
      isLoading={isLoading}
      animation={animation}
      variant="text"
      width={width}
      height={height}
      children={children}
    />
  );
};

TitleSkeleton.defaultProps = {
  animation: 'pulse',
  width: '10.71em',
};

export default TitleSkeleton;
